import { withLogs } from '@core';

import { apiClient, ApiConfig } from '../apiClient';

export type ActivityReport = Record<string, ActivityReportParameter>;

type ActivityReportParameter = {
    displayName: string;
    id: number;
    mean: number;
    name: string;
    stdDev: number;
    unit: string;
};

export const fetchActivityReportById = withLogs(async (activityId: number): Promise<ActivityReport> => {
    const { data } = await apiClient.get<ActivityReport>(ApiConfig.path(`/api/v1/activities/${activityId}/report`));

    return data;
}, 'fetchActivityReportById');
